    
<div *ngIf="medicalBill">

    <p-fieldset legend="Patient Details" toggleable>
        <div class="formgrid grid">
            <div class="col-12">
                <div *ngIf="!medicalBill.patient">
                    <app-party-search #partySearch (partySelected)="patientSelected($event)" placeholder="Search Existing"></app-party-search>
                </div>
                <div *ngIf="medicalBill.patient" class="field w-full formgrid grid align-items-center">
                    <div class="field col-5">
                        <label for="patient">First Name</label>
                        <input id="patient" type="text" pInputText [(ngModel)]="medicalBill.patient.firstName" disabled class="w-full"/>
                    </div>
                    <div class="field col-5">
                        <label for="patient">Last Name</label>
                        <input id="patient" type="text" pInputText [(ngModel)]="medicalBill.patient.lastName" disabled class="w-full"/>
                    </div>
                    <div class="col-2">
                        <div class="flex justify-content-end align-items-end">
                            <p-button icon="pi pi-trash" text (onClick)="clearPatient($event)"></p-button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="medicalBill.patient" class="col-12 formgrid grid">
                <div class="col-6 field" *ngIf="medicalBill.patient.addresses">
                    <p-floatLabel>
                        <p-dropdown id="patientAddress" appendTo="body" [options]="medicalBill.patient.addresses" [(ngModel)]="medicalBill.patientAddress" optionValue="location" styleClass="w-full">
                            <ng-template let-address pTemplate="item">
                                <div *ngIf="address">{{address.location.street1}} {{address.location.street2}} {{address.location.city}} {{address.location.state}} {{address.location.zipCode}}</div>
                            </ng-template>
                            <ng-template let-address pTemplate="selectedItem">
                                <div *ngIf="address">{{address.location.street1}} {{address.location.street2}} {{address.location.city}} {{address.location.state}} {{address.location.zipCode}}</div>
                            </ng-template>
                        </p-dropdown>
                        <label for="patientAddress">Address</label>

                    </p-floatLabel>
                </div>
                <div class="col-6 field"  *ngIf="medicalBill.patient.phones">
                    <p-floatLabel>
                        <p-dropdown id="phone" appendTo="body" [options]="medicalBill.patient.phones" [(ngModel)]="medicalBill.phoneNumber" optionLabel="e164PhoneNumber"  optionValue="phoneNumber" styleClass="w-full"></p-dropdown>
                        <label for="phone">Phone Number</label>
                    </p-floatLabel>
                </div>
                <div class="col-3 field" >
                    <p-floatLabel>
                        <p-dropdown id="gender" appendTo="body" [options]="genders" [(ngModel)]="medicalBill.gender"  styleClass="w-full"></p-dropdown>    
                        <label for="gender">Gender</label>
                    </p-floatLabel>
                </div>
                <div class="col-6 field" >
                    <p-floatLabel>
                        <input id="patientAccount" type="text" pInputText [(ngModel)]="medicalBill.patientAccountNumber" class="w-full"/>    
                        <label for="patientAccount">Patient Account</label>
                    </p-floatLabel>
                </div>
            </div>
        </div>
    </p-fieldset>
    <p-fieldset legend="Insured Detail" toggleable>
        <div class="formgrid grid">
            <div class="col-6 field">
                <p-floatLabel>
                    <input id="insuredName" type="text" pInputText [(ngModel)]="medicalBill.insuredName" class="w-full"/>
                    <label for="insuredName">Insured Name</label>

                </p-floatLabel>
            </div>
            <div class="col-6 field">
                <p-floatLabel>
                    <input id="insuredPhone" type="text" pInputText [(ngModel)]="medicalBill.insuredPhone" class="w-full"/>
                    <label for="insuredPhone">Insured Phone</label>

                </p-floatLabel>
            </div>

            <div *ngIf="medicalBill.insuredAddress" class="flex flex-column">
                <div class="w-full m-1 p-1">
                    <div class="field">
                        <p-floatLabel>
                            <input id="street1" pInputText [(ngModel)]="medicalBill.insuredAddress.street1" class="w-full"/>
                            <label for="street1">Street 1</label>
                        </p-floatLabel>
                    </div>
                    <div class="field pt-2">
                        <p-floatLabel>
                            <input id="street2" pInputText [(ngModel)]="medicalBill.insuredAddress.street2" class="w-full" />
                            <label for="street2">Street 2</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex grid">
                        <div class="field col-6 pt-2">
                            <p-floatLabel>
                                <input id="city" pInputText [(ngModel)]="medicalBill.insuredAddress.city" class="w-full"/>
                                <label for="city">City</label>
                            </p-floatLabel>
                        </div>
                        <div class="field col-3 pt-2">
                            <p-floatLabel>
                                <input id="state" pInputText [(ngModel)]="medicalBill.insuredAddress.state" class="w-full"/>
                                <label for="state">State</label>
                            </p-floatLabel>
                        </div>
                        <div class="field col-3 pt-2">
                            <p-floatLabel>
                                <input id="zipCode" pInputText [(ngModel)]="medicalBill.insuredAddress.zipCode" class="w-full"/>
                                <label for="zipCode">Zip</label>
                            </p-floatLabel>
                        </div>
                    </div>        
                </div> 
            </div>
        </div>
        

    </p-fieldset>
    <p-fieldset legend="Provider Information" toggleable>
        <div class="formgrid grid">
            <div class="col-12">
                <div *ngIf="!medicalBill.servicingProvider" class="w-full">
                    <app-facility-location-search  [(facility)]="medicalBill.servicingProvider"  (facilityChange)="servicingProviderChange($event)" placeholder="Select Servicing Provider"></app-facility-location-search>
                </div>
                <div *ngIf="medicalBill.servicingProvider" class="w-full">
                    <p-card class="w-full" header="Servicing Provider">
                        <div class="flex align-items-center w-full flex-row">
                            <div *ngIf="medicalBill.servicingProvider" class="flex flex-column">
                                <div>{{medicalBill.servicingProvider.facility.name}}</div>
                                <div class="flex flex-column text-xs pt-2">
                                    <div>{{medicalBill.servicingProvider.location.street1}}</div>
                                    <div *ngIf="medicalBill.servicingProvider.location.street2">{{medicalBill.servicingProvider.location.street2}}</div>
                                    <div>{{medicalBill.servicingProvider.location.city}}, {{medicalBill.servicingProvider.location.state}} {{medicalBill.servicingProvider.location.zipCode}}</div>
                                </div>
                            </div>
                            <div class="flex flex-column">
                                <p-button icon="pi pi-trash" text (onClick)="clearServicingProvider($event)"></p-button>
                            </div>
                        </div>
                    </p-card>
                </div>
            </div>
            <div class="col-12">
                <div *ngIf="!medicalBill.billingProvider" class="w-full">
                    <app-facility-location-search  [(facility)]="medicalBill.billingProvider"  (facilityChange)="billingProviderChange($event)" placeholder="Select Billing Provider"></app-facility-location-search>
                </div>
                <div *ngIf="medicalBill.billingProvider" class="w-full pt-2">
                    <p-card class="w-full" header="Billing Provider">
                        <div class="flex align-items-center w-full flex-row">
                            <div *ngIf="medicalBill.billingProvider" class="flex flex-column">
                                <div>{{medicalBill.billingProvider.facility.name}}</div>
                                <div class="flex flex-column text-xs pt-2">
                                    <div>{{medicalBill.billingProvider.location.street1}}</div>
                                    <div *ngIf="medicalBill.billingProvider.location.street2">{{medicalBill.billingProvider.location.street2}}</div>
                                    <div>{{medicalBill.billingProvider.location.city}}, {{medicalBill.billingProvider.location.state}} {{medicalBill.billingProvider.location.zipCode}}</div>
                                </div>
                            </div>
                            <div class="flex flex-column">
                                <p-button icon="pi pi-trash" text (onClick)="clearBillingProvider($event)"></p-button>
                            </div>
                        </div>
                    </p-card>
                </div>
            </div>

        </div>
    </p-fieldset>
    <p-fieldset legend="Line Details" toggleable>
        <p-table [value]="medicalBill.lines" dataKey="procedure.code" > 
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    Lines
                    <p-button icon="pi pi-plus" text (onClick)="addLine($event)" />
                </div>
            </ng-template>
            
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:20%">Procedure</th>
                    <th style="width:15%">Modifiers</th>
                    <th style="width:15%">Diagnosis</th>
                    <th style="width:20%">Service Date</th>
                    <th style="width:15%">Units</th>
                    <th style="width:15%">Cost</th>
                    <th></th>
                </tr>
            </ng-template>

            <ng-template  pTemplate="body" let-line let-editing="editing">
                <tr>
                    <td [pEditableColumn]="line.procedure" pEditableColumnField="procedure">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <app-procedure-selector [(procedure)]="line.procedure"></app-procedure-selector>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <input type="text" pInputText [ngModel]="line.procedure?.code" placeholder="Search Procedure" class="w-full"/>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td [pEditableColumn]="line.modifiers" pEditableColumnField="modifiers">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <app-modifier-selector [(modifiers)]="line.modifiers"></app-modifier-selector>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div class="flex border-round border-1 surface-border p-1 align-items-center" style="height: 2.5rem">
                                    <p-chip *ngFor="let modifier of line.modifiers" [label]="modifier.code"/>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td [pEditableColumn]="line.associatedDiagnosis" pEditableColumnField="associatedDiagnosis">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <app-diagnosis-selector [(diagnoses)]="line.associatedDiagnosis"></app-diagnosis-selector>
                            </ng-template>
                            <ng-template pTemplate="output">
                               <div class="flex border-round border-1 surface-border p-1 align-items-center" style="height: 2.5rem">
                                    <p-chip *ngFor="let diagnosis of line.associatedDiagnosis" [label]="diagnosis.code"/>
                                </div> 
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td [pEditableColumn]="line.dateOfService" pEditableColumnField="dateOfService">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-calendar appendTo="body" [(ngModel)]="line.dateOfService" class="w-full"></p-calendar>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <p-calendar [(ngModel)]="line.dateOfService" styleClass="w-full"></p-calendar>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td [pEditableColumn]="line.units" pEditableColumnField="units">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input id="units" pInputText [(ngModel)]="line.units" class="w-full"/>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <input type="text" pInputText [ngModel]="line.units" placeholder="Units" class="w-full"/>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td class="max-w-min" [pEditableColumn]="line.cost" pEditableColumnField="cost">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-inputNumber id="cost" pInputText [(ngModel)]="line.cost" mode="currency" currency="USD" locale="en-US" />
                            </ng-template>
                            <ng-template pTemplate="output">
                                <p-inputNumber type="text"  [ngModel]="line.cost" placeholder="Cost" mode="currency" currency="USD" locale="en-US"/>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td>
                        <p-button icon="pi pi-trash" text (onClick)="removeLine(line)"/>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-fieldset>

    <div class="flex mt-2 col-12 justify-content-center" >
        <p-buttonGroup>
            <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
            <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
        </p-buttonGroup>
    </div>
</div>
